import { render, staticRenderFns } from "./AgregaVariosSignos.vue?vue&type=template&id=8ac2c8f2&"
import script from "./AgregaVariosSignos.vue?vue&type=script&lang=js&"
export * from "./AgregaVariosSignos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports